/**
 * 6529.io API
 * This is the API interface description. Brief terminology overview and an authentication example can be found at <a href=\"https://6529.io/about/api\">https://6529.io/about/api</a>.
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class SubscriptionTopUp {
    'hash': string;
    'block': number;
    'transaction_date': Date;
    'from_wallet': string;
    'amount': number;
    'created_at'?: Date;

    static readonly discriminator: string | undefined = undefined;

    static readonly mapping: {[index: string]: string} | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "hash",
            "baseName": "hash",
            "type": "string",
            "format": ""
        },
        {
            "name": "block",
            "baseName": "block",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "transaction_date",
            "baseName": "transaction_date",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "from_wallet",
            "baseName": "from_wallet",
            "type": "string",
            "format": ""
        },
        {
            "name": "amount",
            "baseName": "amount",
            "type": "number",
            "format": "double"
        },
        {
            "name": "created_at",
            "baseName": "created_at",
            "type": "Date",
            "format": "date-time"
        }    ];

    static getAttributeTypeMap() {
        return SubscriptionTopUp.attributeTypeMap;
    }

    public constructor() {
    }
}
